<template>
  <div class="parent">
    <div class="headSty">
      <div class="marSty">
        <van-cell center>
          <template #title>
            <div class="icoSty">
              <img
                src="@/assets/images/squirrelCup/2024/cupTwo/yule@2x.png"
                alt=""
              />
              <span class="custom-title"> 娱乐项目</span>
            </div>
          </template>
          <template #right-icon>
            <van-switch v-model="checked.is_open" @change="checkAll(checked)" />
          </template>
        </van-cell>
      </div>
      <div v-if="checked.is_open" class="animate">
        <div class="padSty">
          <van-cell center title="人物装扮（含装扮商城）">
            <template #right-icon>
              <van-switch
                v-model="character.is_open"
                size="24"
                @change="checkChare(character)"
              />
            </template>
          </van-cell>
          <van-cell center title="社交">
            <template #right-icon>
              <van-switch
                v-model="social.is_open"
                size="24"
                @change="checkChare(social)"
              />
            </template>
          </van-cell>
          <van-cell center title="宠物庄园">
            <template #right-icon>
              <van-switch
                v-model="pet.is_open"
                size="24"
                @change="checkChare(pet)"
              />
            </template>
          </van-cell>
        </div>
      </div>
      <div class="history" @click="toHistory">
        管控记录 <van-icon name="arrow" size="18" />
      </div>
    </div>
    <div class="contenSty">
      <div class="friend">
        <spot :title="'好友列表'"></spot>
        <div>（{{ this.total || 0 }}）</div>
      </div>
      <div class="listSty" v-if="friendsList.length > 0">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          :offset="2"
          @load="onLoad"
        >
          <div
            class="cellSty"
            v-for="(item, index) in friendsList"
            :key="index"
          >
            <div class="colSty lockSty" @click="lockInfo(item)">
              查看 <van-icon name="arrow" size="18" />
            </div>

            <div class="top">
              <span>{{ item.name }}</span>
              <span class="colSty">{{ item.attribute }}</span>
            </div>
            <div class="textSty">{{ item.agent_relation }}</div>
            <div class="textSty">
              <span>{{ item.add_time }}</span> <span>{{ item.add_way }}</span>
            </div>
          </div>
        </van-list>
      </div>
      <Empty :word="'暂无好友'" v-else></Empty>
    </div>
    <!-- 查看个人信息 -->
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <div class="block" @click.stop>
          <div class="name">{{ friendObj.name }}</div>
          <div class="fontSty">
            <span>服务中心Id:</span><span>{{ friendObj.service_id }}</span>
          </div>
          <div class="fontSty">
            <span>年级：</span> <span>{{ friendObj.grade }}</span>
          </div>
          <!-- <div class="divider"></div> -->
          <div class="title">当前赛季段位</div>
          <div class="pline">
            <div>语文：{{ friendObj.current_rank?.chinese }}</div>
            <div>数学：{{ friendObj.current_rank?.math }}</div>
            <div>英文：{{ friendObj.current_rank?.english }}</div>
          </div>
          <div class="title">历史最高段位</div>
          <div class="pline">
            <div>语文：{{ friendObj.highest_history_rank?.chinese }}</div>
            <div>数学：{{ friendObj.highest_history_rank?.math }}</div>
            <div>英文：{{ friendObj.highest_history_rank?.english }}</div>
          </div>
          <div class="footer">
            <div>首次PK日期：{{ friendObj.first_pk_time }}</div>
            <div class="megSty">
              <div class="text">
                <div class="num">{{ friendObj.total_pk_num }}</div>
                <div>总PK局数</div>
              </div>
              <div class="text">
                <div class="num">{{ friendObj.schedule_num }}</div>
                <div>赛季数</div>
              </div>
              <div class="text">
                <div class="num">{{ friendObj.title_num }}</div>
                <div>称号数</div>
              </div>
            </div>
          </div>
          <div class="btnSty"><span @click="show = false">我知道了</span></div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Switch, Cell, Overlay } from "vant";
import Empty from "./components/Empty.vue";

import spot from "./components/spot.vue";
import {
  queryentertainmentswitch,
  entertainmentswitch,
  friends,
  frienddetail,
} from "@/api/squirrelCup";

export default {
  data() {
    return {
      show: false,
      checked: {}, // 总开关
      character: {}, //人物开关
      social: {}, // 社交开关
      pet: {}, //宠物开关
      headInfo: {},
      friendsList: [],
      loading: false,
      finished: false,
      friendObj: {},
      page: {
        pageIndex: 0,
        pageSize: 10,
      },
      campusId: "",
      total: null,
    };
  },
  components: {
    [Switch.name]: Switch,
    [Cell.name]: Cell,
    [Overlay.name]: Overlay,
    spot,
    Empty,
  },
  created() {
    this.headInfo = JSON.parse(localStorage.getItem("headInfo"));
    // this.campusId=JSON.parse(localStorage.getItem('userInfoId')).campusId
    this.getSwitchInfo();
    this.onLoad();
  },
  mounted() {
    document.title = "娱乐管控";
  },
  methods: {
    // 获取按钮状态
    getSwitchInfo() {
      let param = {
        account_id: Number(this.headInfo.accountId), // 账号Id
      };
      queryentertainmentswitch({ param }).then((res) => {
        [this.checked, this.character, this.social, this.pet] = [...res.data.switch];
        console.log(this.checked, "==");
      });
    },
    // 好友详情查询
    getFrienddetail(friendId) {
      let pkParams = JSON.parse(localStorage.getItem("pkParams"));

      let param = {
        season_id: this.headInfo.season_id || pkParams.seasonId, //赛季ID
        account_id: Number(this.headInfo.accountId), // 账号Id
        friend_account_id: Number(friendId),
      };
      frienddetail({ param }).then((res) => {
        this.show = true;
        this.friendObj = res.data.detail;
      });
    },
    // 获取好友列表
    queryFriends() {
      let pkParams = JSON.parse(localStorage.getItem("pkParams"));
      let parmDta = {
        ...this.page,
        param: {
          season_id: this.headInfo.season_id || pkParams.seasonId, //赛季ID
          account_id: Number(this.headInfo.accountId), // 账号Id
        },
      };

      friends(parmDta).then((res) => {
        console.log(res);
        this.total = res.data.count;
        this.friendsList = this.friendsList.concat(res.data.friends);
        this.loading = false;
        // if (res.data.body.length  < 10) return (this.finished = true);
        if (this.friendsList.length >= this.total)
          return (this.finished = true);
      });
    },
    onLoad() {
      this.page.pageIndex++;
      this.queryFriends();
    },
    // 开关监控
    switchLog(swObj) {
      let agentUserId = JSON.parse(
        localStorage.getItem("userInfoId")
      )?.agentUserId;

      let param = {
        ...swObj,
        account_id: Number(this.headInfo.accountId),
        agentUserId: Number(agentUserId) || "",
        who: this.headInfo.who || "",
        source: this.headInfo.who ? 1 : 2,
      };
      entertainmentswitch({ param }).then((res) => {
        console.log(res);
      });
    },
    // 总开关
    checkAll(val) {
      console.log(val);
      this.switchLog(val);
      this.character.is_open = this.social.is_open = this.pet.is_open = val.is_open;
    },
    checkSwitch(value) {
      console.log(value);
    },
    checkChare(value) {
      this.switchLog(value);

      console.log(this.checked, this.character, this.social);
    },
    lockInfo(item) {
      this.getFrienddetail(item.account_id);
    },
    toHistory() {
      this.$router.push({
        path: "/winterGame/controlRecord",
      });
    },
  },
};
</script>
<style scoped lang="less">
.parent {
  background: #f6f9fd;
  .history {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 24px;
    color: #58abf6;
    margin-top: 30px;
    margin-bottom: 10px;
    // padding: 0 48px;
    span {
      font-size: 34px;
    }
  }
  .headSty,
  .contenSty {
    padding: 40px 32px 24px 32px;
    margin-bottom: 16px;
    background: #fff;
  }
  .marSty {
    margin: 0 16px;
    /deep/.van-switch__node {
      width: 62px;
      height: 62px;
      top: 2px;
    }
    /deep/.van-switch {
      height: 72px;
      width: 128px;
    }
  }
  /deep/ .van-cell {
    padding-left: 0px;
    padding-right: 0px;
    background: transparent;
    font-size: 32px;
    color: #323232;
  }
  .icoSty {
    display: flex;
    align-items: center;
    font-size: 32px;
    color: #323232;
    font-weight: bold;
    img {
      width: 96px;
      height: 96px;
      margin-right: 24px;
    }
  }
  .animate {
    // animation: identifier 1s;
    background: #f6f9fd;
    border-radius: 16px;
    padding: 32px 0;
    .padSty {
      padding: 0 72px;
    }
    /deep/.van-switch__node {
      width: 43px;
      height: 43px;
      top: 2px;
    }
    /deep/.van-switch {
      height: 52px;
      width: 94px;
    }
  }
  .friend {
    font-size: 32px;
    margin: 30px 0;
    display: flex;
  }
  .listSty {
    height: calc(100vh - 700px);
    overflow: auto;
  }
  .cellSty {
    padding: 0 4;
    font-size: 32px;
    padding: 34px 32px 34px 32px;
    position: relative;
    border-bottom: 1px solid #e6e6e6;
    .top {
      font-size: 32px;
      color: #323232;
      font-weight: bold;
      margin-bottom: 16px;
    }
    .colSty {
      font-size: 28px;
      color: #58abf6;
      font-weight: 400;
      margin-left: 16px;
    }
    .lockSty {
      position: absolute;
      right: 48px;
    }
    .textSty {
      font-size: 24px;
      color: #999999;
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 80%;
    background-color: #fff;
    font-size: 32px;
    border-radius: 24px;
    color: #323232;
    font-size: 28px;
    padding: 48px 56px;
    .name {
      font-size: 32px;

      font-weight: bold;
      margin-bottom: 32px;
    }
    .fontSty {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
    .title {
      background: #e4f1fd;
      padding: 8px 24px;
      font-weight: bold;
      margin-bottom: 24px;
    }
  }
  .divider {
    width: 100%;
    background: #000;
    height: 2px;
  }
  .pline {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 132px;
    margin-bottom: 16px;
  }
  .footer {
    background: #f6f9fd;
    padding: 24px;
    padding-bottom: 16px;
  }
  .megSty {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    .text {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 16px;
      .num {
        font-size: 32px;
        font-weight: bold;
        margin-bottom: 10px;
      }
    }
  }
  .btnSty {
    width: 100%;
    font-weight: bold;
    font-size: 32px;
    color: #58abf6;
    text-align: center;
    margin-top: 66px;
  }
  @keyframes identifier {
    0% {
      opacity: 0;
      height: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
/deep/.van-switch--on {
  background-color: #58abf6;
}
/deep/ .van-switch__node {
  top: -3px;
}
</style>
